import { MyrAPIService } from '../../api/myr/myrAPI';
import { MyrAPIEndpoints } from '../../api/myr/myrAPIEndpoints.constant';

export function memberUpdateProfile(data) {
    return MyrAPIService.sendRequest(MyrAPIEndpoints.PROFILE, 'PUT', data);
}
